/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
declare var webix: any;
declare var FullCalendar: any;
declare var $$: any;
namespace Nobox.CRM {

    class TaskKanbanFilterOption {
        Search: string;
        Tags: string;
        Status: string;
        Color: string;
        View: string;
        DueDate: any;
    }
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class TaskKanbanDialog extends NoboxEntityDialog<TaskRow, any> {
        protected getFormKey() { return TaskForm.formKey; }
        protected getIdProperty() { return TaskRow.idProperty; }
        protected getLocalTextPrefix() { return TaskRow.localTextPrefix; }
        protected getService() { return TaskService.baseUrl; }
        protected getDeletePermission() { return TaskRow.deletePermission; }
        protected getInsertPermission() { return TaskRow.insertPermission; }
        protected getUpdatePermission() { return TaskRow.updatePermission; }
        private boardActive: any;
        private kanbanLayout: any;
        private arrBoard: any[];
        private arrUser: any[] = null;
        private userActive: any = null;
        private elementCopy: JQuery = null;
        private HeaderList = {};
        private isKontak = false;
        private lastListName = null;
        private calendar = null;
        public onBoardRender = () => { };
        private idKanban = "kanban";
        private idCalendar = "calendar";
        private filterRequest = {
            Search: "",
            Status: "",
            Tags: "",
            Color: "",
            View: "All",
            DueDate: {
                start: null,
                end: null
            }
        } as TaskKanbanFilterOption;
        protected form = new TaskForm(this.idPrefix);
        destroy() {

        }
        getListBoard() {
            TaskboardService.List(
                {
                    Sort: ["Id DESC"],
                    ColumnSelection: 1,
                    IncludeColumns: ["Id", "Nama", "Deskripsi"]
                },
                res => {
                    if (res.Entities.length != 0) {
                        $$(this.isKontak ? this.idKanban + "btnAddTask" : "btnAddTask").enable();
                        $$(this.isKontak ? this.idKanban + "btnMenu" : "btnMenu").enable();
                        $$(this.isKontak ? this.idKanban + "btnFilter" : "btnFilter").enable();
                        $$(this.isKontak ? this.idKanban + "search" : "search").enable();
                        //$$("btn-list").enable();
                        //$$("btn-calendar").enable();
                        var arrBoard1 = res.Entities.map(({
                            Id: id,
                            Nama: value,
                            Deskripsi: desc,
                            ...rest
                        }) => ({
                            id,
                            value,
                            desc,
                            ...rest
                        })) as any;
                        this.arrBoard = arrBoard1;
                        $$(this.isKontak ? this.idKanban + "selectBoard" : "selectBoard").define("options", arrBoard1);
                        $$(this.isKontak ? this.idKanban + "selectBoard" : "selectBoard").refresh();
                        if (localStorage.getItem(this.isKontak ? this.idKanban + "lastOpenedProject" : "lastOpenedProject") == null) {
                            this.loadData(arrBoard1[0].id, this._ContactId, this._Dealsid, this._GroupId);
                        } else {
                            if (arrBoard1.find(obj => obj.id == localStorage.getItem(this.isKontak ? this.idKanban + "lastOpenedProject" : "lastOpenedProject")) == undefined) {
                                this.loadData(arrBoard1[0].id, this._ContactId, this._Dealsid, this._GroupId);
                            } else {
                                $$(this.isKontak ? this.idKanban + "selectBoard" : "selectBoard").setValue("");
                                $$(this.isKontak ? this.idKanban + "selectBoard" : "selectBoard").setValue(`${localStorage.getItem(this.isKontak ? this.idKanban + "lastOpenedProject" : "lastOpenedProject")}`);
                                //this.loadData(localStorage.getItem(this.isKontak ?this.idKanban+"lastOpenedProject":"lastOpenedProject"));
                            }
                        }
                    } else {
                        $$(this.isKontak ? this.idKanban + "btnAddTask" : "btnAddTask").disable();
                        $$(this.isKontak ? this.idKanban + "btnMenu" : "btnMenu").disable();
                        $$(this.isKontak ? this.idKanban + "btnFilter" : "btnFilter").disable();
                        $$(this.isKontak ? this.idKanban + "search" : "search").disable();
                        //$$("btn-list").disable();
                        //$$("btn-calendar").disable();
                        $$(this.isKontak ? this.idKanban + "selectBoard" : "selectBoard").define("options", [{ "id": "null123", "value": "Add pipeline first", "desc": "" }]);
                        $$(this.isKontak ? this.idKanban + "selectBoard" : "selectBoard").refresh();
                        webix.ui({
                            view: "template", id: this.isKontak ? this.idKanban : "myBoard", template: "<center>Add pipeline first</center>"
                        }, $$(this.isKontak ? this.idKanban : "myBoard"));
                    }
                    this.onBoardRender();
                }
            )
        }
        formatAutoNumeric(value) {
            var input = $(`<input type="text">`);

            var optionAuto = $.cookie("formatnumber");
            if (optionAuto == null) {
                input.autoNumeric('init');
            } else {
                var formatnumber = JSON.parse(decodeURIComponent(optionAuto));
                if (jQuery.isEmptyObject(formatnumber)) {
                } else {
                    var obj = {};
                    if ('aDec' in formatnumber) {
                        obj["aDec"] = formatnumber["aDec"];
                    }
                    if ('mDec' in formatnumber) {
                        obj["mDec"] = formatnumber["mDec"];
                    }
                    if ('aSep' in formatnumber) {
                        obj["aSep"] = formatnumber["aSep"];
                    }
                    if ('dGroup' in formatnumber) {
                        obj["dGroup"] = formatnumber["dGroup"];
                    }
                    if ('lZero' in formatnumber) {
                        obj["lZero"] = formatnumber["lZero"];
                    }
                    input.autoNumeric('init', obj);
                }
            }

            if (value == "" || value == null) {
                return "0";
            } else {
                input.autoNumeric('set', value);
                return input.val();
            }
        }

        listBoard() {
            if (this.arrUser == null) {
                TaskService.GetUser(
                    {

                    }, (res: any) => {
                        var userActive = res.find(el => el.displayname == Q.Authorization.userDefinition.DisplayName && el.username == Q.Authorization.userDefinition.Username);
                        if (userActive) {
                            this.userActive = userActive.id;
                        }
                        this.arrUser = res.map(({
                            UserId: id,
                            DisplayName: value,
                            UserImage: UserImage,
                            image = UserImage == null ? null : `${"/upload/" + UserImage}`,
                            ...rest
                        }) => ({
                            id,
                            value,
                            image,
                            ...rest
                        }));
                        this.getListBoard();
                    })
            } else {
                this.getListBoard();
            }
        }

        private _scrollDelay: any;
        CustomAutoScroll() {
            const context = webix.DragControl.getContext();
            const node = webix.DragControl.getNode();
            if (node) {
                const nodePos = webix.html.offset(node);
                const viewPos = webix.html.offset($$(this.isKontak ? this.idKanban + "scroll-kanban" : "scroll-kanban").$view);
                const viewPosX = viewPos.x

                const rightNodePos = nodePos.x + nodePos.width;
                const rightViewPos = viewPos.x + viewPos.width;
                const contentWidth = $$(this.isKontak ? this.idKanban + "scroll-kanban" : "scroll-kanban").getBody().$width;
                const scrollPosX = $$(this.isKontak ? this.idKanban + "scroll-kanban" : "scroll-kanban").getScrollState().x;

                if (this._scrollDelay) {
                    clearTimeout(this._scrollDelay)
                };

                if ((rightNodePos > rightViewPos) && (viewPos.width + scrollPosX < contentWidth)) {
                    $$(this.isKontak ? this.idKanban + "scroll-kanban" : "scroll-kanban").scrollTo(scrollPosX + 30);
                    this._scrollDelay = setTimeout(() => this.CustomAutoScroll(), 50);
                } else if ((nodePos.x < viewPos.x) && (scrollPosX > 0)) {
                    $$(this.isKontak ? this.idKanban + "scroll-kanban" : "scroll-kanban").scrollTo(scrollPosX > 10 ? scrollPosX - 30 : 0);
                    this._scrollDelay = setTimeout(() => this.CustomAutoScroll(), 50);
                }
            };
        }

        mappingHeader(item) {
            var arrHeader = [];
            var $this = this;
            item.forEach(x => {
                this.HeaderList[x.ListNama] = x.ListId;
                arrHeader.push({
                    width: 300,
                    rows: [
                        {
                            view: "kanbanheader", type: "sub", label: x.ListNama, link: `${x.ListId}`, on: {
                                onBeforeCardAdd(obj, list) {
                                    obj.type = "task";
                                    obj.tags = [];
                                    obj.color = "#00294d";
                                    obj.ListId = x.ListId;
                                    obj.contacts = $this.contactId;
                                    obj.deal = $this.dealsId;
                                    obj.group = $this.groupId;
                                    obj.text = `New ${x.ListNama} task`;
                                    var index = 0;
                                    $$(this.isKontak ? this.idKanban : "myBoard").serialize().forEach(c => {
                                        if (c.ListId == x.ListId && c.text == obj.text) {
                                            index++;
                                        } else if (c.ListId == x.ListId && c.text == obj.text + ` (${index})`) {
                                            index++;
                                        }
                                    })
                                    if (index != 0) {
                                        obj.text = obj.text + ` (${index})`;
                                    }
                                    obj.write_date = Q.formatDate(new Date(), "yyyy-MM-dd HH:mm:ss");
                                }
                            },
                        },
                        { id: `${x.ListId}`, view: "kanbanlist", status: x.ListNama, type: "cards" }
                    ]
                });
            });
            return arrHeader;
        }
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts[1] == undefined) {
                if (name == "formatdate") {
                    return "DD-MM-YYYY";
                } else if (name == "formattime") {
                    return "HH:mm";
                } else if (name == "timezone") {
                    return "Asia/Jakarta";
                }
            } else {
                return parts[1].split(';').shift();
            }
        }

        mappingItem(item: TaskRow[]) {
            var arrItem = [];
            var timezone = "";
            if (this.getCookie("timezone") == undefined || this.getCookie("timezone") == "" || this.getCookie("timezone") == null) {
                timezone = "Asia/Jakarta";
            } else {
                timezone = this.getCookie("timezone").replace(new RegExp("%2F", 'g'), "/").replace(new RegExp("%2C", 'g'), ",");
            }
            item.forEach(x => {
                arrItem.push({
                    "type": "task",
                    "id": x.Id,
                    "text": x.Nama,
                    "detail": x.Ket,
                    "contacts": x.KontakId,
                    "deal": x.DealId,
                    "group": x.GroupId,
                    "foto": x.KontakFoto,
                    "owner": x.Owner,
                    "isDone": x.IsDone,
                    "hasil": x.Hasil,
                    //"gender": x.KontakGender,
                    "nama": x.KontakNama,
                    //"tipe": x.KontakTipeNama,
                    //"category": x.Category,
                    //harusnya tgl mulai dan selesai tapi belum
                    "start_date": x.Mulai == null ? null : Q.formatDate(new Date(x.Mulai), "yyyy-MM-dd HH:mm:ss"),
                    "end_date": x.Selesai == null ? null : Q.formatDate(new Date(x.Selesai), "yyyy-MM-dd HH:mm:ss"),
                    "tags": x.Tags == "" || x.Tags == null ? [] : x.Tags.split(","),
                    "user_id": x.InBy,
                    "color": this.coloringKanban(x),
                    "priority": x.Color,
                    "write_date": Q.formatDate(new Date(x.In), "yyyy-MM-dd HH:mm:ss"),
                    "attachments": x.Lampiran == null ? [] : JSON.parse(x.Lampiran),
                    "status": x.ListNama,
                    "ListId": x.ListId,
                    "rId": x.Id,
                    "$index": x.Index,
                    "comments": x.Comments.map(c => ({ id: c.Id, user_id: c.UserId, date: moment(c.Up).tz(timezone).toDate(), text: c.Text }))
                });
            });
            return arrItem;
        }

        coloringKanban(item: TaskRow): string {
            var endDate = item.Selesai == null ? null : new Date(item.Selesai);
            var today = new Date();
            var todayOrange = new Date();
            todayOrange.setDate(todayOrange.getDate() + 3);
            if (item.IsDone != null && item.IsDone == 1) {
                return "green";
            } else {
                if (endDate != null) {
                    if (today >= endDate) {
                        return "red";
                    } else if (todayOrange >= endDate) {
                        return "orange";
                    } else {
                        return "#005FB1";
                    }
                } else {
                    return "#00294d";
                }
            }
        }

        renderKanban(arrHeader, arrItem) {
            const images = { jpg: true, jpeg: true, png: true, gif: true };
            function isImage(key) {
                return images[key.toString().toLowerCase()];
            }


            //purely to alter relative paths to images
            webix.type(webix.ui.kanbanlist, {
                name: "cards",
                templateAvatar: function (t, e, i) {
                    if (t.type == "task") {
                        if (Q.isEmptyOrNull(t.contacts)) {
                            return `<span class="webix_icon webix_kanban_icon kbi-account" title=""></span>`;
                        } else {
                            if (!Q.isEmptyOrNull(t.foto)) {
                                return `<img class="avatar" style="max-width: 100%;max-height: 100%;" src="${t.foto}" title="${t.nama}" />`;
                            } else {
                                return `<span class="webix_icon webix_kanban_icon kbi-account" title="${t.nama}"></span>`;
                            }
                        }
                    } else {
                        var n = i._users,
                            a = t.user_id && n.exists(t.user_id) ? n.getItem(t.user_id) : {};
                        return a.image ? "<img class='webix_kanban_avatar' src='" + a.image + "' title='" + (a.value || "") + "'>" : "<span class='webix_icon webix_kanban_icon kbi-account' title='" + (a.value || "") + "'></span>";
                    }
                },
                templateAttachments: function (obj) {
                    let html = "";
                    if (webix.isArray(obj.attachments)) {
                        for (let i in obj.attachments) {
                            let v = obj.attachments[i];
                            let type = (typeof v.Filename === "string" && v.Filename) ? v.Filename.split(".").pop() : "";
                            if (isImage(type)) {
                                html += "<img class='webix_kanban_attachment' src='/upload/" + v.Filename + "'/>";
                                break;
                            }
                        }
                    }
                    return html;
                },
                templateBody(obj) {
                    if (obj.type == "deal") {
                        const html = `
                                      <div>${obj.text}</div>
                                      <div class="lkbadge lkbadge-secondary lkbadge-dim tresury">${obj.CryId} ${$this.formatAutoNumeric(obj.Prc)}</div>
                                      <hr class="solid">
                                      <div class="small text-muted">Created: ${moment(obj.create_date).tz($.cookie('timezone')).format($.cookie('formatdate') + ', ' + $.cookie('formattime'))}</div>
                                      <div class="small text-muted">Modified: ${moment(obj.write_date).tz($.cookie('timezone')).format($.cookie('formatdate') + ', ' + $.cookie('formattime'))}</div>
                                      `;

                        return html;
                    } else {
                        var startEl = "";
                        var endEl = "";
                        var finalEl = "";
                        if (obj.start_date != null) {
                            var momentDate = moment(obj.start_date).tz($.cookie('timezone'));
                            var momentDateNow = moment().tz($.cookie('timezone'));
                            if (momentDate.format("YYYY") == momentDateNow.format("YYYY")) {
                                if (momentDate.format("DD") == momentDateNow.format("DD")) {
                                    startEl = `<span class="fw-bold">today</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                                } else if (moment().tz($.cookie('timezone')).add(1, "d").format("DD") == momentDate.format("DD")) {
                                    startEl = `<span class="fw-bold">tomorrow</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                                } else {
                                    startEl = `<span class="fw-bold">${momentDate.format("MMM DD")}</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                                }
                            } else {
                                startEl = `<span class="fw-bold">${momentDate.format($.cookie('formatdate'))}</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                            }
                        }
                        if (obj.end_date != null) {
                            var momentDate = moment(obj.end_date).tz($.cookie('timezone'));
                            var momentDateNow = moment().tz($.cookie('timezone'));
                            if (momentDate.format("YYYY") == momentDateNow.format("YYYY")) {
                                if (momentDate.format("DD") == momentDateNow.format("DD")) {
                                    endEl = `<span class="fw-bold">today</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                                } else if (moment().tz($.cookie('timezone')).add(1, "d").format("DD") == momentDate.format("DD")) {
                                    endEl = `<span class="fw-bold">tomorrow</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                                } else {
                                    endEl = `<span class="fw-bold">${momentDate.format("MMM DD")}</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                                }
                            } else {
                                endEl = `<span class="fw-bold">${momentDate.format($.cookie('formatdate'))}</span>, <span class="timetask">${momentDate.format($.cookie('formattime'))}</span>`;
                            }
                        }
                        if (startEl != "" && endEl != "") {
                            var startDate = moment(obj.start_date).tz($.cookie('timezone'));
                            var endDate = moment(obj.end_date).tz($.cookie('timezone'));
                            const durationInMilliseconds = endDate.diff(startDate);
                            const duration = moment.duration(durationInMilliseconds);
                            const days = duration.days();
                            const hours = duration.hours();
                            const minutes = duration.minutes();
                            var durEl = "";
                            if (days != 0 && hours != 0 && minutes != 0) {
                                durEl = `<div class="lkbadge lkbadge-secondary lkbadge-dim tresury" title="Task duration ${days} Days ${hours} Hours ${minutes} minutes"><i class="fa fa-clock mr-1" style="margin:auto;"></i> ${days} Days, ${hours}.${minutes} Hours</div>`;
                            } else if (days != 0 && minutes != 0) {
                                durEl = `<div class="lkbadge lkbadge-secondary lkbadge-dim tresury" title="Task duration ${days} Days ${hours} Hours ${minutes} minutes"><i class="fa fa-clock mr-1" style="margin:auto;"></i> ${days} Days, ${minutes} Minutes</div>`;
                            } else if (days != 0 && hours != 0) {
                                durEl = `<div class="lkbadge lkbadge-secondary lkbadge-dim tresury" title="Task duration ${days} Days ${hours} Hours ${minutes} minutes"><i class="fa fa-clock mr-1" style="margin:auto;"></i> ${days} Days, ${hours} Hours</div>`;
                            } else if (hours != 0 && minutes != 0) {
                                durEl = `<div class="lkbadge lkbadge-secondary lkbadge-dim tresury" title="Task duration ${hours} Hours ${minutes} minutes"><i class="fa fa-clock mr-1" style="margin:auto;"></i> ${hours}.${minutes} Hours</div>`;
                            } else if (days != 0) {
                                durEl = `<div class="lkbadge lkbadge-secondary lkbadge-dim tresury" title="Task duration ${days} Days"><i class="fa fa-clock mr-1" style="margin:auto;"></i> ${days} Days</div>`;
                            } else if (hours != 0) {
                                durEl = `<div class="lkbadge lkbadge-secondary lkbadge-dim tresury" title="Task duration ${hours} Hours"><i class="fa fa-clock mr-1" style="margin:auto;"></i> ${hours} Hours</div>`;
                            } else if (minutes != 0) {
                                durEl = `<div class="lkbadge lkbadge-secondary lkbadge-dim tresury" title="Task duration ${minutes} Minutes"><i class="fa fa-clock mr-1" style="margin:auto;"></i> ${minutes} Minutes</div>`;
                            }
                            if (startEl.split(",")[0] == endEl.split(",")[0]) {
                                finalEl = `<div class="small text-muted" title="Task start at ${startDate.format($.cookie('formatdate') + ', ' + $.cookie('formattime'))} end in ${endDate.format($.cookie('formatdate') + ', ' + $.cookie('formattime'))}">${startEl} -${endEl.split(",")[1]}</div>${durEl}`;
                            } else {
                                finalEl = `<div class="small text-muted" title="Task start at ${startDate.format($.cookie('formatdate') + ', ' + $.cookie('formattime'))} end in ${endDate.format($.cookie('formatdate') + ', ' + $.cookie('formattime'))}">${startEl} - ${endEl}</div>${durEl}`;
                            }
                        } else if (startEl != "") {
                            var startDate = moment(obj.start_date).tz($.cookie('timezone'));
                            finalEl = `<div class="small text-muted" title="Task start at ${startDate.format($.cookie('formatdate') + ', ' + $.cookie('formattime'))}">Start ${startEl}</div>`;
                        } else if (endEl != "") {
                            var endDate = moment(obj.end_date).tz($.cookie('timezone'));
                            finalEl = `<div class="small text-muted" title="Task end at ${endDate.format($.cookie('formatdate') + ', ' + $.cookie('formattime'))}">End ${endEl}</div>`;
                        }

                        return `<div>${obj.text}</div>
                                ${finalEl}`;
                    }
                }
            });
            var $this = this;
            if ($$(this.isKontak ? this.idKanban : "myBoard").P.view != "template") {
                $$(this.isKontak ? this.idKanban : "myBoard").clearAll();
            }
            if (arrHeader.length == 0) {
                $$(this.isKontak ? this.idKanban + "btnAddTask" : "btnAddTask").disable();
                $$(this.isKontak ? this.idKanban + "btnFilter" : "btnFilter").disable();
                $$(this.isKontak ? this.idKanban + "search" : "search").disable();
                //$$("btn-list").disable();
                //$$("btn-calendar").disable();
                $$(this.isKontak ? this.idKanban + "scroll-kanban" : "scroll-kanban").show();
                webix.ui({
                    view: "template", id: this.isKontak ? this.idKanban : "myBoard", template: "<center>Add pipeline list first</center>"
                }, $$(this.isKontak ? this.idKanban : "myBoard"));
            } else {
                $$(this.isKontak ? this.idKanban + "btnAddTask" : "btnAddTask").enable();
                $$(this.isKontak ? this.idKanban + "btnFilter" : "btnFilter").enable();
                $$(this.isKontak ? this.idKanban + "search" : "search").enable();
                webix.ui({
                    view: "kanban", id: this.isKontak ? this.idKanban : "myBoard",
                    cols: arrHeader,
                    isKontak: this.isKontak,
                    idKanban: this.idKanban,
                    on: {
                        onBeforeStatusChange(itemId, status, list) {
                            var item = this.getItem(itemId);
                            var statusOld = item.status;
                            var comments = item.comments == null ? [] : item.comments;
                            comments.push({
                                date: new Date(),
                                id: webix.uid(),
                                text: `dipindahkan dari ${statusOld} ke ${status}`,
                                user_id: $this.userActive
                            });
                            item.comments = comments;
                            //$$(this.isKontak ?this.idKanban:"myBoard").updateItem(item.id, item)
                        },
                        onListBeforeDragIn(context, e, list) {
                            $this.CustomAutoScroll.call($this);
                        },
                        onListDragOut() {
                            $this.CustomAutoScroll.call($this);
                        },
                        //onAfterEditorShow: (editor, obj) => {
                        //    editor._header.setValue("Add Task")
                        //    editor._header.datobj.label = "Task";
                        //    editor._removeBtn.setValue("Delete")
                        //    editor._removeBtn.datobj.label = "Delete";
                        //    editor._header.refresh();
                        //    editor._removeBtn.refresh();
                        //},
                        onListItemDblClick: function (id, e, node, list) {
                            var dlg = new TaskDialog();
                            dlg.callbackSave = (res) => {
                                $this.editTask(res);
                            }
                            dlg.callbackDelete = (res) => {
                                $this.deleteTask(res);
                            }
                            if ($(document).width() < 576) {
                                dlg.loadByIdAndOpenDialog(id);
                            } else {
                                dlg.loadByIdAndOpenDialog(id);
                            }
                        },
                        onListItemClick: function (id, e, node, list) {
                            if (e.target.className != "webix_kanban_footer_icon" && e.target.className != "webix_kanban_icon kbi-cogs webix_icon" && e.target.className != "webix_kanban_icon kbi-comment webix_icon" && e.target.className != "webix_kanban_icon_text") {
                                var dlg = new TaskDialog();
                                dlg.callbackSave = (res) => {
                                    $this.editTask(res);
                                }
                                dlg.callbackDelete = (res) => {
                                    $this.deleteTask(res);
                                }
                                if ($(document).width() < 576) {
                                    dlg.loadByIdAndOpenDialog(id);
                                } else {
                                    dlg.loadByIdAndOpenDialog(id);
                                }
                            }
                        },
                        onBeforeCardAction: function (action, id) {
                            if (action === "edit") {
                                var dlg = new TaskDialog();
                                dlg.callbackSave = (res) => {
                                    $this.editTask(res);
                                }
                                dlg.callbackDelete = (res) => {
                                    $this.deleteTask(res);
                                }
                                if ($(document).width() < 576) {
                                    dlg.loadByIdAndOpenDialog(id);
                                } else {
                                    dlg.loadByIdAndOpenDialog(id);
                                }
                            }
                            if (action == "Mark as Done") {
                                var item = $$($this.isKontak ? $this.idKanban : "myBoard").getItem(id);
                                item.isDone = 1;
                                item.color = "green";
                                $$(this.isKontak ? this.idKanban : "myBoard").updateItem(id, item)
                            }
                        },
                    },
                    //userList: true,
                    attachments: "/attachments",
                    //url:"/upload/Kanbanfile",
                    //attachments: window.location.origin+"/FileUpload/Task",
                    //attachments: "",
                    comments: { currentUser: $this.userActive, mentions: true, id: "comments", name: "comments" },
                    data: arrItem,
                    //tags: arrTags,
                    cardActions: [
                        "Mark as Done", "edit", "copy", "remove",
                    ],
                    users: $this.arrUser,
                    //colors: colors_set,
                    save: function (id, operation, update) {
                        var idItem = $$($this.isKontak ? $this.idKanban : "myBoard").getItem(id);
                        var elItem = $(`.webix_list_item.webix_kanban_list_item[webix_l_id='${id}'] .webix_kanban_body`);
                        var lastUpdate = Q.formatDate(new Date(), "yyyy-MM-dd HH:mm:ss");
                        if (operation == "update") {
                            var comments = update.comments == null ? [] : update.comments.map(c => ({ Id: webix.uid(), UserId: c.user_id, Up: c.date, BoardId: $this.boardActive, Text: c.text }));
                            //if ($this.lastListName != update.status) {
                            //    comments.push({
                            //        Up: new Date(),
                            //        Id: webix.uid(),
                            //        BoardId: $this.boardActive,
                            //        Text: `dipindahkan dari ${$this.lastListName} ke ${update.status}`,
                            //        UserId: $this.userActive
                            //    });
                            //}
                            if ($this.HeaderList[update.status] != undefined) {
                                TaskService.Update({
                                    EntityId: id,
                                    Entity: {
                                        Nama: update.text,
                                        ListId: $this.HeaderList[update.status],
                                        Ket: update.detail,
                                        Owner: update.owner,
                                        Mulai: update.start_date,
                                        Selesai: update.end_date,
                                        Hasil: update.hasil,
                                        KontakId: update.contacts,
                                        DealId: update.deal,
                                        GroupId: update.group,
                                        IsDone: update.isDone,
                                        KategoriId: update.kategori,
                                        Index: idItem.$index,
                                        //Color: update.color,
                                        Comments: comments,
                                        Lampiran: update.attachments == null ? null : JSON.stringify(update.attachments),
                                        Tags: update.tags.toString(),
                                        BoardId: $this.boardActive
                                    }
                                }, (res) => {
                                    $this.kanbanLayout.adjust();
                                    if ($this.calendar != null) {
                                        $this.calendar.updateSize();
                                    }
                                }, {
                                    onError: (err) => {
                                    }
                                });
                            } else {

                            }
                        }

                        //insert atau tamabah task card
                        if (operation == "insert") {
                            TaskService.Create({
                                Entity: {
                                    Nama: update.text,
                                    ListId: update.ListId,
                                    Id: id,
                                    Ket: update.detail,
                                    Owner: update.owner,
                                    Mulai: update.start_date,
                                    Selesai: update.end_date,
                                    Hasil: update.hasil,
                                    Index: idItem.$index,
                                    //Color: update.color,
                                    BoardId: $this.boardActive,
                                    KontakId: update.contacts,
                                    IsDone: update.isDone,
                                    KategoriId: update.kategori,
                                    DealId: update.deal,
                                    GroupId: update.group,
                                    Comments: update.comments == null ? null : update.comments.map(c => ({ Id: webix.uid(), UserId: c.user_id, Up: c.date, BoardId: $this.boardActive, Text: c.text })),
                                    Lampiran: update.attachments == null ? null : JSON.stringify(update.attachments),
                                    Tags: update.tags.toString(),
                                }
                            }, (res) => {
                                $this.kanbanLayout.adjust();
                                if ($this.calendar != null) {
                                    $this.calendarInit();
                                    $this.calendar.updateSize();
                                }
                            });
                        }
                        if (operation == "delete") {
                            TaskService.Delete({
                                EntityId: id
                            }, (res) => {
                            });
                        }
                    }
                }, $$(this.isKontak ? this.idKanban : "myBoard"));
                var filterSess = localStorage.getItem($this.isKontak ? $this.idKanban + "filterTask" : "filterTask");
                if (filterSess != undefined) {
                    $this.filterRequest = JSON.parse(filterSess);
                    $this.handlerFilter();
                    if ($$($this.isKontak ? $this.idKanban + 'btn-list' : 'btn-list').getValue() == 1) {
                        $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").clearAll();
                        $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").parse($$($this.isKontak ? $this.idKanban : "myBoard").serialize(), "json");
                    }
                    if ($$($this.isKontak ? $this.idKanban + 'btn-calendar' : 'btn-calendar').getValue() == 1) {
                        $this.calendarInit();
                    }
                }
            }
        }

        public refreshSize() {
            this.kanbanLayout.adjust();
        }

        loadData(boardId, contact = null, dealid = null, groupid = null) {
            this.boardActive = boardId;
            if (this.timerActive) {
                this.onTimesUp($(".btn-auto-refresh").find(".button-inner"), "...");
            }
            Q.serviceCall({
                url: "/Services/" + TaskService.baseUrl + "/KanbanData",
                blockUI: false,
                request: {
                    EqualityFilter: {
                        BoardId: boardId,
                        KontakId: contact,
                        DealId: dealid,
                        GroupId: groupid
                    },
                    Sort: ["Urutan ASC"]
                },
                onSuccess: (res: TaskKanbanResponse) => {
                    this.renderKanban(this.mappingHeader(res.ArrHeader), this.mappingItem(res.ArrItem));
                    if (this.timerActive) {
                        this.element.find(".btn-auto-refresh").find(".button-inner").text("10");
                        this.startTimer(this.element.find(".btn-auto-refresh").find(".button-inner"));
                    }
                    if ($$(this.isKontak ? this.idKanban + 'btn-list' : 'btn-list').getValue() == 1) {
                        $$(this.isKontak ? this.idKanban + "vlist" : "vlist").clearAll(); $$(this.isKontak ? this.idKanban + "vlist" : "vlist").parse($$(this.isKontak ? this.idKanban : "myBoard").serialize(), "json");
                    }
                    if ($$(this.isKontak ? this.idKanban + 'btn-calendar' : 'btn-calendar').getValue() == 1) {
                        this.calendarInit();
                    }
                }
            });
        }

        addTask(res: TaskRow) {
            var item = {
                "id": webix.uid(),
                "text": res.Nama,
                "detail": res.Ket,
                "contacts": res.KontakId,
                "deal": res.DealId,
                "group": res.GroupId,
                "foto": res.KontakFoto,
                "nama": res.KontakNama,
                "hasil": res.Hasil,
                "isDone": res.IsDone,
                "owner": res.Owner,
                "kategori": res.KategoriId,
                //"category": res.Category,
                "start_date": res.Mulai == null ? null : Q.formatDate(new Date(res.Mulai), "yyyy-MM-dd HH:mm:ss"),
                "end_date": res.Selesai == null ? null : Q.formatDate(new Date(res.Selesai), "yyyy-MM-dd HH:mm:ss"),
                "tags": res.Tags == "" || res.Tags == null ? [] : res.Tags.split(","),
                "user_id": res.InBy,
                "color": this.coloringKanban(res),
                "priority": res.Color,
                "write_date": Q.isEmptyOrNull(res.In) ? Q.formatDate(new Date(), "yyyy-MM-dd HH:mm:ss") : Q.formatDate(new Date(res.In), "yyyy-MM-dd HH:mm:ss"),
                "attachments": JSON.parse(res.Lampiran),
                "status": res.ListNama,
                "ListId": res.ListId,
                "rId": res.Id
            };
            $$(this.isKontak ? this.idKanban : "myBoard").add(item);
        }

        editTask(res: TaskRow) {
            var item = {
                "id": res.Id,
                "text": res.Nama,
                "detail": res.Ket,
                "contacts": res.KontakId,
                "deal": res.DealId,
                "group": res.GroupId,
                "foto": res.KontakFoto,
                "nama": res.KontakNama,
                "hasil": res.Hasil,
                "owner": res.Owner,
                "isDone": res.IsDone,
                "kategori": res.KategoriId,
                //"category": res.Category,
                "start_date": res.Mulai == null ? null : Q.formatDate(new Date(res.Mulai), "yyyy-MM-dd HH:mm:ss"),
                "end_date": res.Selesai == null ? null : Q.formatDate(new Date(res.Selesai), "yyyy-MM-dd HH:mm:ss"),
                "tags": res.Tags == "" || res.Tags == null ? [] : res.Tags.split(","),
                "user_id": res.InBy,
                "color": this.coloringKanban(res),
                "priority": res.Color,
                "write_date": Q.formatDate(new Date(res.In), "yyyy-MM-dd HH:mm:ss"),
                "attachments": JSON.parse(res.Lampiran),
                "status": res.ListNama,
                "ListId": res.ListId,
                "rId": res.Id
            };
            $$(this.isKontak ? this.idKanban : "myBoard").updateItem(res.Id, item)
        }

        deleteTask(id: any) {
            $$(this.isKontak ? this.idKanban : "myBoard").remove(id);
        }

        initKanbanBody() {
            var self = this;
            var arrrTags = [];
            TasktagService.List({
                IncludeColumns: ["Nama"],
                ColumnSelection: 1,
            }, (res) => {
                arrrTags = res.Entities.map(person => ({ value: person.Nama, id: person.Nama }));
            });
            var arr = [
                {
                    scroll: "x",
                    view: "scrollview",
                    id: self.isKontak ? self.idKanban + "scroll-kanban" : "scroll-kanban",
                    height: parseFloat($("section.content").css("min-height").replace("px", "")) - 180,
                    body: {
                        view: "kanban", id: self.isKontak ? self.idKanban : "myBoard",
                        cols: [],
                        users: this.arrUser,
                        comments: { currentUser: 9 },
                        data: [],
                        tags: [],
                        cardActions: [
                            //default
                            "Mark as Done", "edit", "copy", "remove",
                        ],
                        on: {
                            onBeforeCardAction: function (action, id) {
                            }
                        },
                        save: function (id, operation, update) {
                        }
                    }
                }
            ] as any[];

            if ($(document).width() < 576) {
                arr.unshift(
                    {
                        view: "toolbar", id: "tlbr2", cols: [
                            { id: this.isKontak ? this.idKanban + "btn-kanban" : "btn-kanban", view: "toggle", type: "iconTop", icon: "mdi mdi-music", label: "Board", value: true },
                            { id: this.isKontak ? this.idKanban + "btn-calendar" : "btn-calendar", view: "toggle", type: "iconTop", icon: "mdi mdi-video", label: "Calendar" },
                            { id: this.isKontak ? this.idKanban + "btn-list" : "btn-list", view: "toggle", type: "iconTop", icon: "mdi mdi-microphone", label: "List" }
                        ]
                    });
                arr.unshift(
                    {
                        view: "toolbar", id: "tlbr2", cols: [
                            {
                                view: "button",
                                type: "icon",
                                id: self.isKontak ? self.idKanban + "btnFilter" : "btnFilter",
                                width: 50,
                                icon: "wxi-filter",
                                label: "",
                                click: function () {
                                    self.showForm("win1", this.$view);
                                    $$("filter-status").define("options", {
                                        data: $$(self.isKontak ? self.idKanban : "myBoard").getStatuses(),
                                        selectAll: true
                                    });
                                    $$("filter-status").refresh();
                                    TasktagService.List({
                                        IncludeColumns: ["Nama"],
                                        ColumnSelection: 1,
                                    }, (res) => {
                                        $$("filter-tags").define("options", {
                                            data: res.Entities.map(person => ({ value: person.Nama, id: person.Nama })),
                                            selectAll: true
                                        });
                                        $$("filter-tags").refresh();
                                    });
                                    $$("filterForm").setValues({
                                        tags: self.filterRequest.Tags,
                                        status: self.filterRequest.Status,
                                        color: self.filterRequest.Color,
                                        view: self.filterRequest.View,
                                        dueDate: {
                                            start: self.filterRequest.DueDate.start == null ? null : new Date(self.filterRequest.DueDate.start),
                                            end: self.filterRequest.DueDate.end == null ? null : new Date(self.filterRequest.DueDate.end),
                                        },
                                    });
                                }
                            },
                            { view: "search", align: "center", placeholder: "Cari..", id: self.isKontak ? self.idKanban + "search" : "search", width: "auto" },
                        ]
                    });
                arr.unshift(
                    {
                        view: "toolbar", id: "tlbr12", cols: [
                            {
                                view: "button", id: self.isKontak ? self.idKanban + "btnAddBoard" : "btnAddBoard", label: "Pipeline", type: "icon", icon: "wxi-plus", click: () => {
                                    var dlg = new TaskboardDialog();
                                    dlg.reloadBoard = () => { this.listBoard() };
                                    dlg.loadNewAndOpenDialog(true);
                                }
                            },
                            {
                                view: "button", id: self.isKontak ? self.idKanban + "btnAddTask" : "btnAddTask", label: "Task", type: "icon", icon: "wxi-plus", click: function () {
                                    var dlg = new TaskDialog();
                                    dlg.callbackSave = (res) => {
                                        self.addTask(res);
                                        if ($$(self.isKontak ? self.idKanban + 'btn-list' : 'btn-list').getValue() == 1) {
                                            $$(self.isKontak ? self.idKanban + "vlist" : "vlist").clearAll(); $$(self.isKontak ? self.idKanban + "vlist" : "vlist").parse($$(self.isKontak ? self.idKanban : "myBoard").serialize(), "json");
                                        }
                                        if ($$(self.isKontak ? self.idKanban + 'btn-calendar' : 'btn-calendar').getValue() == 1) {
                                            self.calendarInit();
                                        }
                                    }
                                    dlg.callbackDelete = (res) => {
                                        self.deleteTask(res);
                                        if ($$(self.isKontak ? self.idKanban + 'btn-list' : 'btn-list').getValue() == 1) {
                                            $$(self.isKontak ? self.idKanban + "vlist" : "vlist").clearAll(); $$(self.isKontak ? self.idKanban + "vlist" : "vlist").parse($$(self.isKontak ? self.idKanban : "myBoard").serialize(), "json");
                                        }
                                        if ($$(self.isKontak ? self.idKanban + 'btn-calendar' : 'btn-calendar').getValue() == 1) {
                                            self.calendarInit();
                                        }
                                    }
                                    dlg.loadEntityAndOpenDialog({
                                        BoardId: self.boardActive,
                                        KontakId: self.contactId,
                                        DealId: self.dealsId,
                                        GroupId: self.groupId
                                    });
                                }
                            }
                        ]
                    });
                arr.unshift(
                    {
                        view: "toolbar", id: "tlbr1", cols: [
                            {
                                view: "select",
                                label: "",
                                labelAlign: "center",
                                id: self.isKontak ? self.idKanban + "selectBoard" : "selectBoard",
                                width: "auto",
                                value: 1, options: [{ "id": "null123", "value": "Add pipeline first", "desc": "" }]
                            },
                            {
                                view: "button", id: self.isKontak ? self.idKanban + "btnMenu" : "btnMenu", label: "", type: "icon", icon: "wxi-dots", width: 50, click: function () {
                                    self.showForm("win2", this.$view);
                                    var ab = self.arrBoard.find(obj => obj.id == self.boardActive)
                                    $$("menuForm").setValues({
                                        id: ab.id,
                                        name: ab.value,
                                        desc: ab.desc
                                    })
                                }
                            }
                        ]
                    });
                arr.push(
                {
                    hidden: true,
                    height: parseFloat($("section.content").css("min-height").replace("px", "")) - 180,
                    id: self.isKontak ? self.idKanban + "vlist" : "vlist",
                    view: "datatable",
                    sort: true,
                    headermenu: true,
                        dragscroll: true,
                        scrollX: true,
                    dragColumn: true,
                    drag: true,
                    columns: [
                        {
                            id: "user_id", header: "Assign", css: "Assign", template: function (obj) {
                                var i = self.arrUser.map(function (e) { return e.id }).indexOf(parseInt(obj.user_id));
                                if (i == -1) {
                                    return `<div1 style="margin-bottom:5px;margin-right:2px;display: inline-block;" title="no assign user" class="avatar text-center bg-light"><span class="webix_icon webix_kanban_icon kbi-account"></span></div1>No Assign User`
                                } else {
                                    if (self.arrUser[i].image != undefined) {
                                        return `<img class="avatar" title="${self.arrUser[i].value}" src="${self.arrUser[i].image}" style="margin-bottom:5px;margin-right:2px;height:20px;">${self.arrUser[i].value}`
                                    } else {
                                        return `<div style="margin-bottom:5px;margin-right:2px;display: inline-block;" title="${self.arrUser[i].value}" class="avatar text-center bg-light"><span class="webix_icon webix_kanban_icon kbi-account"></span></div1>${self.arrUser[i].value}`
                                    }
                                }
                            }, width: 150, sort: "string"
                        },
                        { id: "text", header: "Title", template: "<strong>#text#</strong>",  width: 200,sort: "string" },
                        { id: "status", header: "Stage (List)", width: 100, sort: "string" },
                        {
                            id: "start_date", header: "Start Date", width: 135, template: function (obj) {
                                var format = webix.Date.dateToStr("%d-%M-%Y %H:%i");
                                var stringTgl = format(new Date(obj.start_date));
                                if (obj.start_date == null || obj.start_date == undefined || obj.start_date == "") {
                                    return "Start Date Not Set";
                                } else {
                                    return stringTgl;
                                }
                            }, sort: "string"
                        },
                        {
                            id: "end_date", header: "End Date", width: 135, template: function (obj) {
                                var format = webix.Date.dateToStr("%d-%M-%Y %H:%i");
                                var stringTgl = format(new Date(obj.end_date));
                                if (obj.end_date == null || obj.end_date == undefined || obj.end_date == "") {
                                    return "End Date Not Set";
                                } else {
                                    return stringTgl;
                                }
                            }, sort: "string"
                        },
                        {
                            id: "tags", header: "Tags", template: function (obj) {
                                if (obj.tags == "" || obj.tags == undefined) {
                                    return "No Tags";
                                } else {
                                    return obj.tags.toString()
                                }
                            }, width: 100, sort: "string"
                        },
                        {
                            id: "write_date", header: "Last Update", width: 135, template: function (obj) {
                                var format = webix.Date.dateToStr("%d-%M-%Y %H:%i");
                                var stringTgl = format(new Date(obj.write_date));
                                return stringTgl;
                            }, sort: "string"
                        }
                    ],
                    resizeColumn: true,
                    on: {
                        "onItemClick": function (id, e, trg) {
                            var dlg = new TaskDialog();
                            dlg.callbackSave = (res) => {
                                self.editTask(res);
                                $$(self.isKontak ? self.idKanban + "vlist" : "vlist").clearAll(); $$(self.isKontak ? self.idKanban + "vlist" : "vlist").parse($$(self.isKontak ? self.idKanban : "myBoard").serialize(), "json");
                            }
                            dlg.callbackDelete = (res) => {
                                self.deleteTask(res);
                                $$(self.isKontak ? self.idKanban + "vlist" : "vlist").clearAll(); $$(self.isKontak ? self.idKanban + "vlist" : "vlist").parse($$(self.isKontak ? self.idKanban : "myBoard").serialize(), "json");
                            }
                            dlg.loadByIdAndOpenDialog(id.row);
                        }
                    }
                })
            } else {
                arr.unshift(
                    {
                        view: "toolbar", id: "tlbr2", cols: [
                            {
                                view: "button",
                                id: self.isKontak ? self.idKanban + "btnFilter" : "btnFilter",
                                width: 100, value: 'Filter',
                                click: function () {
                                    self.showForm("win1", this.$view);
                                    $$("filter-status").define("options", {
                                        data: $$(self.isKontak ? self.idKanban : "myBoard").getStatuses(),
                                        selectAll: true
                                    });
                                    $$("filter-status").refresh();
                                    TasktagService.List({
                                        IncludeColumns: ["Nama"],
                                        ColumnSelection: 1,
                                    }, (res) => {
                                        $$("filter-tags").define("options", {
                                            data: res.Entities.map(person => ({ value: person.Nama, id: person.Nama })),
                                            selectAll: true
                                        });
                                        $$("filter-tags").refresh();
                                    });
                                    $$("filterForm").setValues({
                                        tags: self.filterRequest.Tags,
                                        status: self.filterRequest.Status,
                                        color: self.filterRequest.Color,
                                        view: self.filterRequest.View,
                                        dueDate: {
                                            start: self.filterRequest.DueDate.start == null ? null : new Date(self.filterRequest.DueDate.start),
                                            end: self.filterRequest.DueDate.end == null ? null : new Date(self.filterRequest.DueDate.end),
                                        },
                                    });
                                }
                            },
                            { view: "search", align: "center", placeholder: "Cari..", id: self.isKontak ? self.idKanban + "search" : "search", width: 300 },
                            {},
                            { id: this.isKontak ? this.idKanban + "btn-kanban" : "btn-kanban", autowidth: true, minWidth: 80, view: "toggle", type: "iconTop", icon: "mdi mdi-music", label: "Kanban", value: true },
                            { id: this.isKontak ? this.idKanban + "btn-calendar" : "btn-calendar", autowidth: true, view: "toggle", type: "iconTop", icon: "mdi mdi-video", label: "Calendar" },
                            { id: this.isKontak ? this.idKanban + "btn-list" : "btn-list", autowidth: true, view: "toggle", type: "iconTop", icon: "mdi mdi-microphone", label: "List" }
                        ]
                    });
                arr.unshift(
                    {
                        view: "toolbar", id: "tlbr1", cols: [
                            {
                                view: "select",
                                label: "Pipeline",
                                labelAlign: "center",
                                id: self.isKontak ? self.idKanban + "selectBoard" : "selectBoard",
                                width: 300,
                                value: 1, options: [{ "id": "null123", "value": "Add pipeline first", "desc": "" }]
                            },
                            {},
                            {
                                view: "button", id: self.isKontak ? self.idKanban + "btnAddBoard" : "btnAddBoard", label: "Pipeline", type: "icon", icon: "wxi-plus", width: 120, click: () => {
                                    var dlg = new TaskboardDialog();
                                    dlg.reloadBoard = () => { this.listBoard() };
                                    dlg.loadNewAndOpenDialog();
                                }
                            },
                            {
                                view: "button", id: self.isKontak ? self.idKanban + "btnAddTask" : "btnAddTask", label: "Task", type: "icon", icon: "wxi-plus", width: 120, click: function () {
                                    var dlg = new TaskDialog();
                                    dlg.callbackSave = (res) => {
                                        self.addTask(res);
                                    }
                                    dlg.callbackDelete = (res) => {
                                        self.deleteTask(res);
                                    }
                                    dlg.loadEntityAndOpenDialog({
                                        BoardId: self.boardActive,
                                        KontakId: self.contactId,
                                        DealId: self.dealsId,
                                        GroupId: self.groupId
                                    });
                                }
                            },
                            {
                                view: "button", id: self.isKontak ? self.idKanban + "btnMenu" : "btnMenu", label: "", type: "icon", icon: "wxi-dots", width: 50, click: function () {
                                    self.showForm("win2", this.$view);
                                    var ab = self.arrBoard.find(obj => obj.id == self.boardActive)
                                    $$("menuForm").setValues({
                                        id: ab.id,
                                        name: ab.value,
                                        desc: ab.desc
                                    })
                                }
                            }
                        ]
                    });
                arr.push(
                    {
                        hidden: true,
                        height: parseFloat($("section.content").css("min-height").replace("px", "")) - 180,
                        id: self.isKontak ? self.idKanban + "vlist" : "vlist",
                        view: "datatable",
                        sort: true,
                        headermenu: true,
                        dragscroll: true,
                        dragColumn: true,
                        drag: true,
                        columns: [
                            {
                                id: "user_id", header: "Assign", css: "Assign", template: function (obj) {
                                    var i = self.arrUser.map(function (e) { return e.id }).indexOf(parseInt(obj.user_id));
                                    if (i == -1) {
                                        return `<div1 style="margin-bottom:5px;margin-right:2px;display: inline-block;" title="no assign user" class="avatar text-center bg-light"><span class="webix_icon webix_kanban_icon kbi-account"></span></div1>No Assign User`
                                    } else {
                                        if (self.arrUser[i].image != undefined) {
                                            return `<img class="avatar" title="${self.arrUser[i].value}" src="${self.arrUser[i].image}" style="margin-bottom:5px;margin-right:2px;height:20px;">${self.arrUser[i].value}`
                                        } else {
                                            return `<div style="margin-bottom:5px;margin-right:2px;display: inline-block;" title="${self.arrUser[i].value}" class="avatar text-center bg-light"><span class="webix_icon webix_kanban_icon kbi-account"></span></div1>${self.arrUser[i].value}`
                                        }
                                    }
                                }, fillspace: 1.5, sort: "string"
                            },
                            { id: "text", header: "Title", template: "<strong>#text#</strong>", fillspace: 2.5, sort: "string" },
                            { id: "status", header: "Stage (List)", fillspace: 1, sort: "string" },
                            {
                                id: "start_date", header: "Start Date", fillspace: 1.5, template: function (obj) {
                                    var format = webix.Date.dateToStr("%d-%M-%Y %H:%i");
                                    var stringTgl = format(new Date(obj.start_date));
                                    if (obj.start_date == null || obj.start_date == undefined || obj.start_date == "") {
                                        return "Start Date Not Set";
                                    } else {
                                        return stringTgl;
                                    }
                                }, sort: "string"
                            },
                            {
                                id: "end_date", header: "End Date", fillspace: 1.5, template: function (obj) {
                                    var format = webix.Date.dateToStr("%d-%M-%Y %H:%i");
                                    var stringTgl = format(new Date(obj.end_date));
                                    if (obj.end_date == null || obj.end_date == undefined || obj.end_date == "") {
                                        return "End Date Not Set";
                                    } else {
                                        return stringTgl;
                                    }
                                }, sort: "string"
                            },
                            {
                                id: "tags", header: "Tags", template: function (obj) {
                                    if (obj.tags == "" || obj.tags == undefined) {
                                        return "No Tags";
                                    } else {
                                        return obj.tags.toString()
                                    }
                                }, fillspace: 1, sort: "string"
                            },
                            {
                                id: "write_date", header: "Last Update", fillspace: 1.5, template: function (obj) {
                                    var format = webix.Date.dateToStr("%d-%M-%Y %H:%i");
                                    var stringTgl = format(new Date(obj.write_date));
                                    return stringTgl;
                                }, sort: "string"
                            }
                        ],
                        resizeColumn: true,
                        on: {
                            "onItemClick": function (id, e, trg) {
                                var dlg = new TaskDialog();
                                dlg.callbackSave = (res) => {
                                    self.editTask(res);
                                    $$(self.isKontak ? self.idKanban + "vlist" : "vlist").clearAll(); $$(self.isKontak ? self.idKanban + "vlist" : "vlist").parse($$(self.isKontak ? self.idKanban : "myBoard").serialize(), "json");
                                }
                                dlg.callbackDelete = (res) => {
                                    self.deleteTask(res);
                                    $$(self.isKontak ? self.idKanban + "vlist" : "vlist").clearAll(); $$(self.isKontak ? self.idKanban + "vlist" : "vlist").parse($$(self.isKontak ? self.idKanban : "myBoard").serialize(), "json");
                                }
                                dlg.loadByIdAndOpenDialog(id.row);
                            }
                        }
                    });
            }
            return arr;
        }
        calendarInit() {
            var self = this;
            var arrCalendar = function () {
                var arrTempCalendar = [];
                if ($$(self.isKontak ? self.idKanban : "myBoard").P.view != "template") {
                    var arrItemCal = $$(self.isKontak ? self.idKanban : "myBoard").serialize();
                    arrItemCal.forEach(e => {
                        var obj = {
                            id: e.id,
                            title: e.text,
                            className: `fc-event-${e.color == "green" ? "success" : e.color == "red" ? "danger" : e.color}`,
                            start: e.start_date,
                            end: e.end_date,
                            allDay: true,
                        };
                        //obj.id = e.id;
                        //obj.title = e.text;
                        //if (e.start_date != "") {
                        //    obj.start = e.start_date;
                        //}
                        //if (e.end_date != "") {
                        //    obj.end = e.end_date;
                        //}
                        //if (e.color == undefined || e.color == "") {
                        //    obj.className = "fc-event-primary";
                        //} else {
                        //    obj.className = `fc-event-${obj.color}`;
                        //}
                        arrTempCalendar.push(obj)
                    })
                }
                return arrTempCalendar;
            }

            this.calendar = new FullCalendar.Calendar(this.isKontak ? document.getElementById(this.idCalendar) : document.getElementById('calendar'), {
                timeZone: localStorage.getItem("non_tz") || "America/New_York",
                locale: localStorage.getItem("non_lang") || "en",
                initialView: 'dayGridMonth',
                themeSystem: 'bootstrap',
                headerToolbar: {
                    left: 'prev next',
                    center: 'title',
                    right: 'today dayGridMonth,timeGridWeek,timeGridDay,listMonth'
                },
                height: 800,
                contentHeight: 780,
                aspectRatio: 3,
                editable: true,
                droppable: true,
                views: {
                    dayGridMonth: {
                        dayMaxEventRows: 2
                    }
                },
                now: new Date(),
                nowIndicator: true,
                eventContent: function (arg) {
                    var view = arg.view.type;
                    arg.isEnd = true;
                    arg.isStart = false;
                    arg.isStartResizable = false;
                    arg.isEndResizable = true;
                    if (view == "dayGridMonth") {
                        if (arg.event.allDay) {
                            return { html: `<div class="fc-event-time">${moment(arg.event._def.extendedProps.startdate).format('HH:mm')}</div><div class="fc-event-title">${arg.event._def.title}</div>` }
                        } else {
                            return { html: `<div class="fc-event-time">${moment(arg.event._def.extendedProps.startdate).format('HH:mm')}</div><div class="fc-event-title">${arg.event._def.title}</div>` }
                        }
                    }
                },
                dateClick: function (info) {
                    var startDate = moment(new Date(info.dateStr)).format();
                    var endDate = new Date(info.dateStr);
                    endDate.setHours(19);
                    //var dlg = new TaskDialog();
                    //dlg.callbackSave = (res) => {
                    //    self.addTask(res);
                    //}
                    //dlg.callbackDelete = (res) => {
                    //    self.deleteTask(res);
                    //}
                    //dlg.loadEntityAndOpenDialog({
                    //    BoardId: self.boardActive
                    //}, true);
                    //$$(this.isKontak ?this.idKanban:"myBoard").showEditor();
                    //$$(this.isKontak ?this.idKanban:"myBoard").getEditor().setValues({ end_date: Q.formatDate(endDate, "yyyy-MM-dd HH:mm:ss"), start_date: startDate })
                    var dlg = new TaskDialog();
                    dlg.callbackSave = (res) => {
                        self.addTask(res);
                        self.calendar.removeAllEvents();
                        var arr = arrCalendar();
                        arr.forEach(ce => {
                            self.calendar.addEvent(ce);
                        });
                        setTimeout(() => {
                            self.calendar.updateSize();
                        }, 100)
                    }
                    dlg.callbackDelete = (res) => {
                        self.deleteTask(res);
                        self.calendar.removeAllEvents();
                        var arr = arrCalendar();
                        arr.forEach(ce => {
                            self.calendar.addEvent(ce);
                        });
                        setTimeout(() => {
                            self.calendar.updateSize();
                        }, 100)
                    }
                    dlg.loadEntityAndOpenDialog({
                        BoardId: self.boardActive,
                        Mulai: startDate,
                        Selesai: moment(endDate).format(),
                        KontakId: self.contactId,
                        DealId: self.dealsId,
                        GroupId: self.groupId
                    });
                },
                eventResize: function (info) {
                    var item = $$(self.isKontak ? self.idKanban : "myBoard").getItem(info.event.id)
                    item.end_date = info.event.end == null ? null : moment(info.event.end).utc().format();
                    $$(this.isKontak ? this.idKanban : "myBoard").updateItem(info.event.id, item)
                },
                eventDrop: function (info) {
                    var item = $$(self.isKontak ? self.idKanban : "myBoard").getItem(info.event.id)
                    item.start_date = info.event.start == null ? null : moment(info.event.start).utc().format();
                    item.end_date = info.event.end == null ? null : moment(info.event.end).utc().format()
                    $$(this.isKontak ? this.idKanban : "myBoard").updateItem(info.event.id, item)
                },
                eventDragStart: function eventDragStart(info) {
                },
                eventMouseEnter: function eventMouseEnter(info) {
                },
                eventMouseLeave: function eventMouseLeave(info) {
                },
                eventClick: function eventClick(info) {
                    var dlg = new TaskDialog();
                    dlg.callbackSave = (res) => {
                        self.editTask(res);
                        self.calendar.removeAllEvents();
                        var arr = arrCalendar();
                        arr.forEach(ce => {
                            self.calendar.addEvent(ce);
                        });
                        setTimeout(() => {
                            self.calendar.updateSize();
                        }, 100)
                    }
                    dlg.callbackDelete = (res) => {
                        self.deleteTask(res);
                        self.calendar.removeAllEvents();
                        var arr = arrCalendar();
                        arr.forEach(ce => {
                            self.calendar.addEvent(ce);
                        });
                        setTimeout(() => {
                            self.calendar.updateSize();
                        }, 100)
                    }
                    dlg.loadByIdAndOpenDialog($$(self.isKontak ? self.idKanban : "myBoard").getItem(`${info.event.id}`).id);
                },
                events: arrCalendar(),
            });
            self.calendar.render();
        }

        initKanban() {
            var self = this;
            this.kanbanLayout = webix.ui({
                id: "layoutKanban",
                container: self.isKontak ? self.idKanban : "kanban",
                rows: self.initKanbanBody()
            });

            $$(self.isKontak ? self.idKanban + "search" : "search").attachEvent("onTimedKeyPress", function () {
                //get user input value
                var value = this.getValue().toLowerCase();
                self.filterRequest.Search = value;
                self.handlerFilter();
            });
            this.popupMenu();
            var calendarEl = this.isKontak ? $("#" + self.idCalendar) : $("#calendar");
            $$(self.isKontak ? self.idKanban + "btn-kanban" : "btn-kanban").attachEvent("onItemClick", function (id, e) {
                $$(self.isKontak ? self.idKanban + 'btn-list' : 'btn-list').setValue(0);
                $$(self.isKontak ? self.idKanban + 'btn-calendar' : 'btn-calendar').setValue(0);
                $$(self.isKontak ? self.idKanban + "scroll-kanban" : "scroll-kanban").show();
                calendarEl.html("");
                calendarEl.attr("css", "pt-2");
                calendarEl.hide();
                $$(self.isKontak ? self.idKanban + "vlist" : "vlist").hide();
                localStorage.setItem(self.isKontak ? self.idKanban + "taskState" : "taskState", self.isKontak ? self.idKanban + "btn-kanban" : "btn-kanban");
            });
            $$(self.isKontak ? self.idKanban + "btn-calendar" : "btn-calendar").attachEvent("onItemClick", function (id, e) {
                $$(self.isKontak ? self.idKanban + 'btn-kanban' : 'btn-kanban').setValue(0);
                $$(self.isKontak ? self.idKanban + 'btn-list' : 'btn-list').setValue(0);
                $$(self.isKontak ? self.idKanban + "scroll-kanban" : "scroll-kanban").hide();
                calendarEl.show();
                //$("#kwrap-container").append(`<div id="calendar" style="background-color:white;"></div>`);
                /*Calendar*/
                self.calendarInit();
                $$(self.isKontak ? self.idKanban + "vlist" : "vlist").hide();
                localStorage.setItem(self.isKontak ? self.idKanban + "taskState" : "taskState", self.isKontak ? self.idKanban + "btn-calendar" : "btn-calendar");
            });
            $$(self.isKontak ? self.idKanban + "btn-list" : "btn-list").attachEvent("onItemClick", function (id, e) {
                $$(self.isKontak ? self.idKanban + 'btn-kanban' : 'btn-kanban').setValue(0);
                $$(self.isKontak ? self.idKanban + 'btn-calendar' : 'btn-calendar').setValue(0);
                $$(self.isKontak ? self.idKanban + "scroll-kanban" : "scroll-kanban").hide();
                calendarEl.html("");
                calendarEl.attr("css", "pt-2");
                calendarEl.hide();
                $$(self.isKontak ? self.idKanban + "vlist" : "vlist").clearAll(); $$(self.isKontak ? self.idKanban + "vlist" : "vlist").parse($$(self.isKontak ? self.idKanban : "myBoard").serialize(), "json");
                $$(self.isKontak ? self.idKanban + "vlist" : "vlist").show();
                $$("layoutKanban").resize();
                localStorage.setItem(self.isKontak ? self.idKanban + "taskState" : "taskState", self.isKontak ? self.idKanban + "btn-list" : "btn-list");
            });
        }

        popupMenu() {
            var $this = this;
            webix.ui({
                view: "popup",
                id: "win2",
                width: 300,
                head: false,
                body: {
                    view: "form",
                    id: "menuForm",
                    borderless: true,
                    elements: [
                        //{ view: "label", label: "Nama Project", autowidth: true, align: "left" },
                        //{
                        //    view: "template",
                        //    template: `<div class="p-2 ">Erik Setiadi</div>`,
                        //    id: "board-name-menu",
                        //    autowidth: true,
                        //},
                        { view: "text", label: 'Pipeline Name', css: "board-name-menu", name: "name", readonly: true, borderless: true, disabled: true },
                        {
                            view: "textarea",
                            label: 'Description',
                            css: "board-desc-menu",
                            height: 150,
                            name: "desc",
                            readonly: true,
                            disabled: true
                        },
                        {
                            cols: [
                                {
                                    view: "button", value: "Edit", click: () => {
                                        $$("win2").hide();
                                        //$('#editBoardPopup').lkmodal('show');
                                        //boardEditAmbilValue();
                                        var dlg = new TaskboardDialog();
                                        dlg.reloadBoard = () => { this.listBoard() };
                                        if ($(document).width() < 576) {
                                            dlg.loadByIdAndOpenDialog($this.boardActive);
                                        } else {
                                            dlg.loadByIdAndOpenDialog($this.boardActive);
                                        }
                                    }
                                },
                                {
                                    view: "button", value: "Delete", click: function () {
                                        webix.confirm({
                                            title: "Are you sure you want to delete this pipeline?",
                                            ok: "Yes", cancel: "No",
                                            text: "Data in this pipeline will be delete permanent"
                                        })
                                            .then(function () {
                                                TaskboardService.Delete(
                                                    {
                                                        EntityId: $this.boardActive,
                                                    },
                                                    res => {
                                                        $$("win2").hide();
                                                        $this.listBoard();
                                                    }
                                                )
                                                //Nobox.CRM.TasksprojectsService.Delete(
                                                //    {
                                                //        EntityId: boardActive,
                                                //    },
                                                //    res => {
                                                //        $$("win2").hide()
                                                //        getBoard();
                                                //    }
                                                //)
                                            });
                                    }
                                }
                            ],
                        }
                    ],
                    elementsConfig: {
                        labelPosition: "top",
                    }
                }
            });

            webix.ui({
                view: "popup",
                id: "win1",
                width: 300,
                css: "popupfilter",
                head: false,
                body: {
                    view: "form",
                    id: "filterForm",
                    borderless: true,
                    elements: [
                        {
                            view: "multiselect",
                            label: 'Tags',
                            name: "tags",
                            id: "filter-tags",
                            options: {
                                data: [],
                                selectAll: true
                            }
                        },
                        {
                            view: "multiselect",
                            label: 'Status',
                            name: "status",
                            id: "filter-status",
                            options: {
                                data: [],
                                selectAll: true
                            }
                        },
                        {
                            view: "multiselect",
                            label: 'Priority',
                            name: "color",
                            id: "filter-color",
                            options: {
                                data: [
                                    { id: "#005FB1", value: "None" },
                                    { id: "green", value: "Low" },
                                    { id: "orange", value: "Medium" },
                                    { id: "red", value: "High" }
                                ],
                                selectAll: true
                            }
                        },
                        {
                            view: "select",
                            label: 'View',
                            name: "view",
                            id: "filter-view",
                            options: [
                                { id: "All", value: "All" },
                                { id: "Done", value: "Done" },
                                { id: "Undone", value: "Undone" }
                            ]
                        },
                        {
                            view: "daterangepicker",
                            label: 'Due Date',
                            name: "dueDate",
                            id: "filter-due",
                        },
                        {
                            cols: [
                                {
                                    view: "button", value: "Reset", click: function () {
                                        $$($this.isKontak ? $this.idKanban : "myBoard").filter();
                                        $this.filterRequest.Search = "";
                                        $this.filterRequest.Tags = "";
                                        $this.filterRequest.Status = "";
                                        $this.filterRequest.Color = "";
                                        $this.filterRequest.View = "All";
                                        $this.filterRequest.DueDate = {
                                            start: null,
                                            end: null
                                        };
                                        this.getTopParentView().hide();
                                        if ($$($this.isKontak ? $this.idKanban + 'btn-list' : 'btn-list').getValue() == 1) {
                                            $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").clearAll(); $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").parse($$($this.isKontak ? $this.idKanban : "myBoard").serialize(), "json");
                                        }
                                        if ($$($this.isKontak ? $this.idKanban + 'btn-calendar' : 'btn-calendar').getValue() == 1) {
                                            $this.calendarInit();
                                        }
                                        localStorage.removeItem($this.isKontak ? $this.idKanban + "filterTask" : "filterTask");
                                    }
                                },
                                {
                                    view: "button", value: "Apply", click: function () {
                                        $$($this.isKontak ? $this.idKanban : "myBoard").filter();
                                        var values = $$("filterForm").getValues();
                                        //var text = values.text;
                                        $this.filterRequest.Tags = values.tags;
                                        $this.filterRequest.Status = values.status;
                                        $this.filterRequest.Color = values.color;
                                        $this.filterRequest.View = values.view;
                                        $this.filterRequest.DueDate = values.dueDate;
                                        localStorage.setItem($this.isKontak ? $this.idKanban + "filterTask" : "filterTask", JSON.stringify($this.filterRequest));
                                        $this.handlerFilter();
                                        this.getTopParentView().hide();
                                        if ($$($this.isKontak ? $this.idKanban + 'btn-list' : 'btn-list').getValue() == 1) {
                                            $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").clearAll();
                                            $$($this.isKontak ? $this.idKanban + "vlist" : "vlist").parse($$($this.isKontak ? $this.idKanban : "myBoard").serialize(), "json");
                                        }
                                        if ($$($this.isKontak ? $this.idKanban + 'btn-calendar' : 'btn-calendar').getValue() == 1) {
                                            $this.calendarInit();
                                        }
                                    }
                                }
                            ],
                        }
                    ],
                    elementsConfig: {
                        labelPosition: "top",
                    }
                }
            });
        }

        handlerFilter() {
            var self = this;
            //if (this.filterRequest.Status != "") {
            //    var arrSts = this.filterRequest.Status.split(",");
            //    $$(this.isKontak ?this.idKanban:"myBoard").filter(function (obj) {
            //        return arrSts.some(i => i.includes(obj.$list));
            //    });
            //}
            $$(self.isKontak ? self.idKanban : "myBoard").filter(function (obj) {
                var search = obj.text.toLowerCase().includes(self.filterRequest.Search.toLowerCase());
                var tags = true;
                var status = true;
                var color = true;
                var view = true;
                var dueDate = true;
                if (!Q.isEmptyOrNull(self.filterRequest.Tags)) {
                    var arrTags = self.filterRequest.Tags.split(",");
                    tags = arrTags.some(i => obj.tags.includes(i))
                }
                if (!Q.isEmptyOrNull(self.filterRequest.Status)) {
                    var arrSts = self.filterRequest.Status.split(",");
                    status = arrSts.some((i: any) => i.includes(obj.$list));
                }
                if (!Q.isEmptyOrNull(self.filterRequest.Color)) {
                    var arrColor = self.filterRequest.Color.split(",");
                    color = arrColor.some((i: any) => i.includes(obj.priority));
                }
                if (!Q.isEmptyOrNull(self.filterRequest.View) && self.filterRequest.View != "All") {
                    if (self.filterRequest.View == "Done") {
                        view = obj.isDone == 1;
                    } else {
                        view = obj.isDone == 0;
                    }
                }
                
                if (self.filterRequest.DueDate != { start: null, end: null }) {
                    if (obj.start_date == null) {
                        dueDate = false;
                    } else {
                        var start = moment(self.filterRequest.DueDate.start).tz($.cookie('timezone'));
                        var taskStart = moment(obj.start_date, "YYYY-MM-DD HH:mm:ss").tz($.cookie('timezone'));
                        if (obj.end_date != null) {
                            var taskEnd = moment(obj.end_date, "YYYY-MM-DD HH:mm:ss").tz($.cookie('timezone'));
                            if (self.filterRequest.DueDate.end != null) {
                                var end = moment(self.filterRequest.DueDate.end).tz($.cookie('timezone'));
                                var startDate = taskStart;
                                if (taskStart.isBefore(taskEnd)) {
                                    while (startDate.isBefore(taskEnd) || startDate.isSame(taskEnd, 'day')) {
                                        if (startDate.isBetween(start, end, null, '[]')) {
                                            dueDate = true;
                                            startDate = moment(obj.end_date, "YYYY-MM-DD HH:mm:ss").tz($.cookie('timezone'));
                                            startDate.add(10, 'days');
                                        } else {
                                            dueDate = false;
                                            startDate.add(1, 'days');
                                        }
                                    }
                                } else {
                                    dueDate = false;
                                }
                            } else {
                                dueDate = start.isBetween(taskStart, taskEnd, null, '[]');
                            }
                        } else {
                            if (self.filterRequest.DueDate.end != null) {
                                var end = moment(self.filterRequest.DueDate.end).tz($.cookie('timezone'));
                                dueDate = taskStart.isBetween(start, end, null, '[]');
                            } else {
                                dueDate = start.isSame(taskStart);
                            }
                        }
                    }
                }
                return search && status && tags && color && view && dueDate;
            });
            //$$(this.isKontak ?this.idKanban:"myBoard").filter("#text#", this.filterRequest.Search);
        }

        showForm(winId, node) {
            $$(winId).getBody().clear();
            $$(winId).show(node);
            $$(winId).getBody().focus();
        }

        dialogClose() {
            if (this.isKontak) {
                super.dialogClose();
            }
        }

        private _ContactId: number = null;

        get contactId() {
            return this._ContactId;
        }
        set contactId(value: number) {
            if (this._ContactId !== value) {
                this._ContactId = value;
                this.listBoard();
            }
        }

        private _GroupId: number = null;

        get groupId() {
            return this._GroupId;
        }
        set groupId(value: number) {
            if (this._GroupId !== value) {
                this._GroupId = value;
                this.listBoard();
            }
        }

        private _Dealsid: number = null;

        get dealsId() {
            return this._Dealsid;
        }
        set dealsId(value: number) {
            if (this._Dealsid !== value) {
                this._Dealsid = value;
                this.listBoard();
            }
        }

        //dialogCloseConfirmation(element: JQuery) {
        //    element.bind('dialogbeforeclose', function (e) {
        //        if (!Serenity.WX.hasOriginalEvent(e)) {
        //            return;
        //        }
        //        e.preventDefault();
        //        Q.confirm('Do you really want to close this dialog?',
        //            () => { element.dialog().dialog('close'); },
        //            {
        //                onNo: function () {
        //                    return;
        //                }

        //            });
        //    });
        //}

        constructor(container?: JQuery, calenderEl?: JQuery, isKontak: boolean = false) {
            super(container);
            var $this = this;
            if (container) {
                this.idKanban = container.attr("id");
            }
            if (calenderEl) {
                this.idCalendar = calenderEl.attr("id");
            }
            this.isKontak = isKontak;
            this.initKanban();
            if (!isKontak) {
                this.listBoard();
                $.fn.remove = function (e) {
                    if (this.hasClass("s-Nobox-CRM-TaskKanbanDialog")) {
                        this.removeClass("hidden");
                        this.removeClass("panel-hidden");
                        return this;
                    } else {
                        return this.each(function () {
                            if (this.parentNode) {
                                this.parentNode.removeChild(this);
                            }
                        });
                    }
                }
                var parent = this.element.get(0);
                var observer = new MutationObserver(function (mutationsList) {
                    for (var mutation of mutationsList) {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                            if ($(document).width() > 576) {
                                if ($this.element.hasClass('hidden')) {
                                    $this.element.removeClass("hidden");
                                } else if ($this.element.hasClass('panel-hidden')) {
                                    $this.element.removeClass("panel-hidden");
                                }
                            }
                        }
                    }
                });

                // Configure and start the observer
                observer.observe(parent, { attributes: true });
                //var divCopy = $("#ContainerKanban");
                //this.element.children("#kanban").detach().appendTo(divCopy);
                //this.element.children("#calendar").detach().appendTo(divCopy);
                //this.elementCopy = divCopy;
            } else {
                //this.elementCopy = this.element;
            }
            //this.dialogCloseConfirmation(this.element);
            if (localStorage.getItem(this.isKontak ? this.idKanban + "taskState" : "taskState") != undefined) {
                $$(localStorage.getItem(this.isKontak ? this.idKanban + "taskState" : "taskState")).callEvent("onItemClick");
            }
            webix.event(window, "resize", () => { this.kanbanLayout.adjust(); });
            $$(this.isKontak ? this.idKanban + "selectBoard" : "selectBoard").attachEvent("onChange", (newValue, oldValue, config) => {
                if (newValue != "") {
                    this.loadData(newValue, this._ContactId, this._Dealsid, this._GroupId);
                    localStorage.setItem(this.isKontak ? this.idKanban + "lastOpenedProject" : "lastOpenedProject", newValue);
                }
            });
            $(".s-sidebar-band-link.s-sidebar-pane-toggle-link").on("click", () => {
                setTimeout(() => {
                    this.kanbanLayout.adjust();
                }, 500)
            })
        }

        getTemplate() {
            //return `<div id="kanban"></div>
            //        <div id="calendar" class="pt-2"style="display:none;"></div>
            //        <div class="s-Form d-none">
            //            <form id="~_Form" action="">
            //                <div class="fieldset ui-widget ui-widget-content ui-corner-all">
            //                    <div id="~_PropertyGrid"></div>
            //                    <div class="clear"></div>
            //                </div>
            //            </form>
            //        </div>
            //        <div id="~_Toolbar"  class="s-DialogToolbar mt-3 p-toolbar d-none">
            //        </div>`;
            return `<div id="kanban"></div>
                    <div id="calendar" class="pt-2"style="display:none;"></div>`;
        }

        protected updateInterface() {
            super.updateInterface();
        }

        protected updateTitle() {
            this.dialogTitle = "Tasks";
        }

        private WARNING_THRESHOLD = 5;
        private ALERT_THRESHOLD = 3;
        private TIME_LIMIT = 10;
        private timeLeft = this.TIME_LIMIT;
        private timePassed = 0;
        private timerInte
        rval = null;
        private refreshInterval = null;
        private timerActive = false;
        private COLOR_CODES = {
            info: {
                color: "green"
            },
            warning: {
                color: "orange",
                threshold: this.WARNING_THRESHOLD
            },
            alert: {
                color: "red",
                threshold: this.ALERT_THRESHOLD
            }
        };
        formatTime(time) {
            const minutes = Math.floor(time / 60);
            let seconds = time % 60 as any;

            if (seconds < 10) {
                seconds = `0${seconds}`;
            }
            if (seconds == 0) {
                seconds = `...`;
            }

            return `${seconds}`;
        }
        calculateTimeFraction() {
            const rawTimeFraction = this.timeLeft / this.TIME_LIMIT;
            return rawTimeFraction - (1 / this.TIME_LIMIT) * (1 - rawTimeFraction);
        } onTimesUp(e, h = null) {
            clearInterval(this.timerInterval);
            if (this.refreshInterval != null) {
                clearInterval(this.refreshInterval);
            }
            if (h != "...") {
                e.html("<i class=\"fa fa-stopwatch text-blue\"></i>");
                this.timerActive = false;
            } else {
                e.html(h);
                this.timerActive = true;
            }
            this.WARNING_THRESHOLD = 5;
            this.ALERT_THRESHOLD = 3;
            this.TIME_LIMIT = 10;
            this.timePassed = 0;
            this.timeLeft = 10;
            this.timerInterval = null;
            this.refreshInterval = null;
        }
        setRemainingPathColor(timeLeft, e) {
            const { alert, warning, info } = this.COLOR_CODES;
            if (timeLeft <= alert.threshold) {
                e.removeClass(warning.color);
                e.addClass(alert.color);
            } else if (timeLeft <= warning.threshold) {
                e.removeClass(info.color);
                e.addClass(warning.color);
            } else if (timeLeft >= warning.threshold) {
                e.removeClass(alert.color);
                e.addClass(info.color);
            }
        }
        startTimer(e) {
            this.timerActive = true;
            this.refreshInterval = setInterval(() => {
                //refresh();
                //setYearCampaign(ThisYear)
                this.loadData(this.boardActive, this._ContactId, this._Dealsid, this._GroupId);
            }, 10000);
            e.removeClass(this.COLOR_CODES.info.color);
            e.removeClass(this.COLOR_CODES.alert.color);
            e.removeClass(this.COLOR_CODES.warning.color);
            e.addClass(this.COLOR_CODES.info.color);
            this.timerInterval = setInterval(() => {
                this.timePassed = this.timePassed += 1;
                this.timeLeft = this.TIME_LIMIT - this.timePassed;
                e.text(this.formatTime(
                    this.timeLeft
                ));
                this.setRemainingPathColor(this.timeLeft, e);

                if (this.timeLeft === 0) {
                    this.WARNING_THRESHOLD = 5;
                    this.ALERT_THRESHOLD = 3;
                    this.TIME_LIMIT = 10;
                    this.timePassed = 0;
                    this.timeLeft = 10;
                }
            }, 1000);
        }
        dialogOpen() {
            super.dialogOpen();

            this.element.children("div.panel-titlebar").find("button.panel-titlebar-close").remove();
            this.element.children("div.panel-titlebar").append(`
        <div style="border-radius: 4px;border: 1px solid var(--s-tool-border);margin-left:auto;" class="btn btn-icon btn-sm p-0 ml-2">
            <div class="tool-button btn-autorefresh icon-tool-button btn-auto-refresh" title="Auto Refresh in 10 seconds">
                <div class="button-outer">
                    <span class="button-inner green">
                        <i class="fa fa-stopwatch text-blue"></i>
                    </span>
                </div>
            </div>
        </div><a style="border-radius: 4px;border: 1px solid var(--s-tool-border);margin-left:5px;" class="btn btn-icon btn-sm btn-panduan p-0 ml-1 float-right" target="_blank" href="/panduan/absensidialog">
                <div class="tool-button icon-tool-button py-1" title="Panduan">
                    <div class="button-outer">
                        <span class="button-inner green">
                            <i class="fa fa-play-circle text-blue"></i>
                        </span>
                    </div>
                </div>
            </a>`);
            this.element.find(".btn-auto-refresh").on('click', (e) => {
                if (!this.timerActive) {
                    if ($(e.currentTarget).hasClass("tool-button")) {
                        $(e.currentTarget).find(".button-inner").text("10");
                        this.startTimer($(e.currentTarget).find(".button-inner"));
                    } else {
                        $(e.currentTarget).parents(".tool-button").find(".button-inner").text("10")
                        this.startTimer($(e.currentTarget).parents(".tool-button").find(".button-inner"));
                    }
                } else {
                    if ($(e.currentTarget).hasClass("tool-button")) {
                        this.onTimesUp($(e.currentTarget).find(".button-inner"));

                    } else {
                        this.onTimesUp($(e.currentTarget).parents(".tool-button").find(".button-inner"));
                    }
                }
            });
            Q.Router.replace("");

            //setTimeout(() => {
            //}, 400);

            this.kanbanLayout.adjust();
        }
    }
}